import { Request } from 'commons/utils/request'
import { ExportCSVButton } from 'ui/temp/ExportCSVButton'

import { useDocumentStatusReportContext } from '../../context/reportContext'

export const Actions = () => {
  const {
    data: { form }
  } = useDocumentStatusReportContext()

  return (
    <ExportCSVButton
      reportName="Document Status"
      url={Request.urls.bank.portalReportDocumentStatusCSV}
      parametersForm={form}
    />
  )
}
